'use client';

import { MobileNav as ChromeMobileNav } from '@/components/chrome/mobile-nav';
import { NAVIGATION } from '@/lib/navigation';
import { trackThemeToggle } from '@/lib/analytics';

/**
 * Mobile navigation — thin wrapper around the registry-installed chrome
 * drawer. Site config lives here; rendering in @/components/chrome/mobile-nav.
 */
export function MobileNav() {
  return <ChromeMobileNav sections={NAVIGATION.mobile} onThemeChange={trackThemeToggle} />;
}
